(function () {
    'use strict';

    angular
        .module('app.widgets')
        .directive('obtMatch', obtMatch);

    function obtMatch () {
        return {
            require: 'ngModel',
            restrict: 'A',
            scope: {
                match: '=obtMatch'
            },
            link: link
        };
    }

    function link(scope, elem, attrs, ctrl) {
        scope.$watch(function() {
            return (ctrl.$pristine && angular.isUndefined(ctrl.$modelValue)) || scope.match === ctrl.$modelValue;
        }, function(currentValue) {
            ctrl.$setValidity('match', currentValue);
        });
    }
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/obt-Match.directive.js
 ** module id = 179
 ** module chunks = 0
 **/